import React, { useContext, useEffect, useState } from "react";
import { useHeaderTitle } from "../../../components/layout/layout";
import Overview from "../../../components/JobDetails/overview";
import Details from "../../../components/JobDetails/Details";
import Candidates from "../../../components/JobDetails/candidates";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import jobApi from "../../../services/jobApi"; // <-- Your API service
import { toast } from "react-toastify";
import { AssignContextprovider } from "../../../context/AssignContext";

export default function JobDetails() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { jobDetailId } = useParams();

    const [selectedTab, setSelectedTab] = useState("overview");
    const { setHeaderTitle } = useHeaderTitle();

    // State for job details
    const [jobDetails, setJobDetails] = useState(null);

    useEffect(() => {
        if (!user) {
            navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`, { replace: true });
        }
    }, [user, navigate, location.pathname]);

    useEffect(() => {
        setHeaderTitle("Job Details");
        location.state?.fromCandidateDetails && setSelectedTab("candidates");
    }, [setHeaderTitle, location.state]);

    // Fetch job details
    useEffect(() => {
        if (!jobDetailId) return;
        const fetchJob = async () => {
            const response = await jobApi.getJobDetailById(jobDetailId);
            setJobDetails(response?.data);
        };
        fetchJob();
    }, [jobDetailId]);

    if (!user) return null;
    if (!jobDetailId) {
        return <div>Invalid job. Please go back to the job list.</div>;
    }
    

    // --- Approve Button Logic ---
    let showApprove = false;
    if (jobDetails) {
        const isWaiting = jobDetails.jobStatus === "waitingforapproval";
        const isSuperAdmin = user.roleId === 1;
        const isApprover = Array.isArray(jobDetails.approverIds) && jobDetails.approverIds.includes(user.id);
        showApprove = isWaiting && (isSuperAdmin || isApprover);
    }

    // Approve handler
    const handleApprove = async () => {
        debugger
        try {
            debugger
            const response = await jobApi.approveJob(jobDetailId); // Adjust this to your actual API method
            if (response?.ok) {
                toast.success("Job approved successfully!");
                // Optionally, refresh job details:
                const updated = await jobApi.getJobDetailById(jobDetailId);
                setJobDetails(updated?.data);
            } else {
                toast.error("Failed to approve job.");
            }
        } catch (error) {
            toast.error("Error approving job.");
        }
    };

    return (
        <section className="job-details-wrapper common-tab-container">
            <div className="d-flex justify-content-between align-items-start">
                <div className="w-100">
                    <div className='tabMenu common-tab-nav d-flex mb-4'>
                        {/* ...tab buttons as before... */}
                        <div
                            className={`tabButton d-flex align-items-center ${selectedTab === "overview" ? "active" : ""}`}
                            onClick={() => setSelectedTab("overview")} title="overview">
                            {/* ...icon... */} Overview
                        </div>
                        <div
                            className={`tabButton d-flex align-items-center ${selectedTab === "details" ? "active" : ""}`}
                            onClick={() => setSelectedTab("details")} title="details">
                            {/* ...icon... */} Details
                        </div>
                        <div
                            className={`tabButton d-flex align-items-center ${selectedTab === "candidates" ? "active" : ""}`}
                            onClick={() => setSelectedTab("candidates")} title="candidates">
                            {/* ...icon... */} Candidates
                        </div>
                        <div
                            className={`tabButton d-flex align-items-center ${selectedTab === "AI" ? "active" : ""}`}
                            onClick={() => setSelectedTab("AI")} title="AI">
                            {/* ...icon... */} AI
                        </div>
                        {/* RHS Approve Panel */}
                {showApprove && (
                    <div className="aproval-action ms-auto">
                        <button
                            className="btn btn-success w-100 mb-2"
                            onClick={handleApprove}
                        >
                            Approve
                        </button>
                        {/* You can add more approval info here */}
                    </div>
                )}
                    </div>
                    <div className='tabContent common-tab-content'>
                   
                        {selectedTab === "overview" && (
                            <div className='tab-inner'>
                                <Overview jobDetailId={jobDetailId} />
                            </div>
                        )}
                        {selectedTab === "details" && (
                            <div className='tab-inner'>
                                <Details jobDetailId={jobDetailId} jobDetails={jobDetails} />
                            </div>
                        )}
                        {selectedTab === "candidates" && (
                            <div className='tab-inner list-holder'>
                                <AssignContextprovider>
                                    <Candidates jobDetailId={jobDetailId} />
                                </AssignContextprovider>
                            </div>
                        )}
                        {selectedTab === "AI" && (
                            <div className='tab-inner'>
                                AI
                            </div>
                        )}
                    </div>
                </div>
                
            </div>
        </section>
    );
}